"use client";

import { useId } from "react";
import { StyledSlider } from "@/components/ui/slider";
import { cn } from "@/lib/utils";

interface SliderControlProps
  extends Omit<
    React.ComponentProps<typeof StyledSlider>,
    "children" | "defaultValue" | "onChange" | "onValueChange" | "value"
  > {
  label: React.ReactNode;
  onChange: (value: number) => void;
  value: number;
  valueLabel: React.ReactNode;
}

export default function SliderControl({
  label,
  onChange,
  value,
  valueLabel,
  className,
  ...sliderProps
}: SliderControlProps) {
  const labelId = useId();

  return (
    <div className={cn("flex w-full flex-col gap-3", className)}>
      <div className="flex w-full select-none items-center justify-between text-sm">
        <span className="font-medium text-gray-1200" id={labelId}>
          {label}
        </span>
        <span className="font-berkeley-mono text-gray-1000 tabular-nums">
          {valueLabel}
        </span>
      </div>
      <StyledSlider
        aria-labelledby={labelId}
        {...sliderProps}
        onValueChange={onChange}
        value={value}
      />
    </div>
  );
}
